import axios from "axios";
import { useState } from "react";
import config from "../../../config";
import { Transition } from "@headlessui/react";

function FunctieToevoegen(props) {
	const [notification, setNotification] = useState( {show: false, msg: ""} );

	const [functieNaam, setFunctieNaam] = useState("");
	const [functieMail, setFunctieMail] = useState("");

	function functieAsMail() {
		setFunctieMail(functieNaam.toLowerCase() + "@hermesgent.be");
	}

	function voegFunctieToe() {
		let data = {
			name: functieNaam,
			order: 99999,
			email: functieMail,
		};
		axios.post(config.api_url + "/functies/", data).then((response) => {
			notify(<p className="text-zinc-200">Aanmaken van {data.name} succesvol!</p>);
            setFunctieMail("")
            setFunctieNaam("")
			props.reRender();
		});
	}
	function notify(msg){
		setNotification({show: true, msg: msg})
		setTimeout(() => {
			setNotification({show: false, msg: msg});
		}, 5000)
	}

	return (
		<div className="my-8 mx-auto w-full lg:w-11/12">
			<h2 className="mb-4 font-bold text-zinc-600 text-2xl text-center">Functie toevoegen</h2>
			<Transition show={notification.show} enter="transition-opacity duration-150" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
				<div className="fixed bottom-4 right-6 z-[1000] bg-zinc-800 px-6 py-3 text-zinc-200 rounded-md shadow-md max-w-m">{notification.msg}</div>
			</Transition>
			<label htmlFor="functieNaam" className="text-lg font-light text-zinc-600 dark:text-zinc-500">
				Functie Titel
			</label>
			<input id="functieNaam" value={functieNaam} onChange={(e) => setFunctieNaam(e.target.value)} type="text" className="border border-zinc-300 focus:outline-none focus:ring-1 focus:ring-blue-600 bg-transparent dark:border-zinc-700 w-full rounded-md px-3 py-2 dark:text-zinc-500 mb-4" placeholder="Vb: Praeses" />
			<div className="flex items-center mb-2">
				<label htmlFor="functieMail" className="text-lg font-light text-zinc-600 dark:text-zinc-500">
					Functie Email
				</label>
				<button onClick={() => functieAsMail()} className="bg-blue-600 px-3 py-1 text-xs text-white ml-3 rounded-full">
					{functieNaam ? functieNaam.toLowerCase() + "@hermesgent.be" : "functie@hermesgent.be"}
				</button>
			</div>
			<input id="functieMail" value={functieMail} onChange={(e) => setFunctieMail(e.target.value)} type="email" className="border border-zinc-300 focus:outline-none focus:ring-1 focus:ring-blue-600 bg-transparent dark:border-zinc-700 w-full rounded-md px-3 py-2 dark:text-zinc-500 mb-4" placeholder="Functie email" />
			<button onClick={() => voegFunctieToe()} className="bg-blue-700 text-md px-6 py-2 text-white font-bold rounded-lg mt-8 hover:bg-blue-200 hover:text-blue-800 transition-colors flex items-center">
				Toevoegen
			</button>
		</div>
	);
}

export default FunctieToevoegen;
